import { PlayerModel } from './player.model';
import { TeamModel } from './team.model';
import { VenueModel } from './venue.model';

export class GameModel{
    public mlbid:any = '';
    public name = '';
    public awayTeam: TeamModel = new TeamModel();
    public homeTeam: TeamModel = new TeamModel();
    public channels: string[] = [];
    public get channelsText(): string {
        let text = '';
        for(const i in this.channels){
            text += (text == '' ? '' : ', ') + this.channels[i];
        }
        return text;
    }
    public dateStart:Date = new Date();
    public get timeStart(): string {
        const hours = this.dateStart.getHours() < 10 ? '0' + this.dateStart.getHours() : this.dateStart.getHours();
        const minutes = this.dateStart.getMinutes() < 10 ? '0' + this.dateStart.getMinutes() : this.dateStart.getMinutes();
        return hours + ':' + minutes;
    }

    public get dateDay(): string {
        return this.dateStart.getDate() < 10 ? '0' + this.dateStart.getDate() : this.dateStart.getDate().toString();
    }

    public get dateMonth(): string {
        return this.dateStart.getMonth() + 1 < 10 ? '0' + (this.dateStart.getMonth() + 1) : (this.dateStart.getMonth() + 1).toString();
    }

    public get dateYear(): string {
        return this.dateStart.getFullYear() < 10 ? '0' + this.dateStart.getFullYear() : this.dateStart.getFullYear().toString();
    }

    public gamesTicket = '';
    public onDemand = '';
    public streaming = '';
    public probableAwayPlayer: PlayerModel = new PlayerModel();
    public probableHomePlayer: PlayerModel = new PlayerModel();
    public status = '';
    public get statusText(): string {
        return '';
    };
    public streamingId = '';
    public venue: VenueModel = new VenueModel();

    public get isPreview(): boolean{
        return this.status.toLowerCase() == 'planned' ? true : false;
    }

    public get isTerminated(): boolean{
        return this.status.toLowerCase() == 'terminate' ? true : false;
    }

    public get isLive(): boolean{
        return this.status.toLowerCase() == 'live' ? true : false;
    }

    public get isFinal(): boolean{
        return this.status.toLowerCase() == 'on demand' ? true : false;
    }

    public get isCancelled(): boolean{
        return this.status.toLowerCase() == 'cancelado' ? true : false;
    }

    public get isPostponed(): boolean{
        return this.status.toLowerCase() == 'pospuesto' ? true : false;
    }
}